import React from "react";
import { Button, Col, Form, Input, Row, Select, Space, Typography } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface Props {
  /** Form.List name path. Example: "extraFields" */
  name: string | (string | number)[];
}

/**
 * Editor for vendor extra_fields. Mirrors Magento admin's dynamic_rows:
 * each row has { label, type ("1" input | "2" select), options }.
 * "options" doubles as placeholder text for input-type fields.
 */
export const ExtraFieldsEditor: React.FC<Props> = ({ name }) => (
  <div>
    <Text strong>Preguntas al cliente en checkout</Text>
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <div style={{ marginTop: 8 }}>
          {fields.map((field) => (
            <Row key={field.key} gutter={8} align="middle" style={{ marginBottom: 8 }}>
              <Col span={9}>
                <Form.Item
                  {...field}
                  name={[field.name, "label"]}
                  label={field.name === 0 ? "Etiqueta" : ""}
                  rules={[{ required: true, message: "Requerido" }]}
                  style={{ marginBottom: 0 }}
                >
                  <Input placeholder="Ej: Nombre del barrio" />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item
                  {...field}
                  name={[field.name, "type"]}
                  label={field.name === 0 ? "Tipo" : ""}
                  rules={[{ required: true }]}
                  style={{ marginBottom: 0 }}
                >
                  <Select
                    options={[
                      { value: "1", label: "Texto" },
                      { value: "2", label: "Select" },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  {...field}
                  name={[field.name, "options"]}
                  label={field.name === 0 ? "Placeholder / Opciones (separadas por coma)" : ""}
                  style={{ marginBottom: 0 }}
                >
                  <Input placeholder="Opción 1, Opción 2, Opción 3" />
                </Form.Item>
              </Col>
              <Col span={2} style={{ display: "flex", alignItems: "center" }}>
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  danger
                  onClick={() => remove(field.name)}
                />
              </Col>
            </Row>
          ))}
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={() => add({ label: "", type: "1", options: "" })}
            block
          >
            Agregar pregunta
          </Button>
        </div>
      )}
    </Form.List>
  </div>
);
